import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';

/**
 * The list of tabs on this page
 */
export enum ExperienceOverviewPageTabId {
	Overview = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum ExperienceOverviewPageViewId {
	Overview = 1,
}


@Injectable({ providedIn: 'root' })
export class ExperienceOverviewService extends PageTabsLayoutPageService<ExperienceOverviewPageTabId, ExperienceOverviewPageViewId> {
	private static readonly _viewDroplistItems: DroplistItem<never, ExperienceOverviewPageViewId>[] = [
		{
			uniqueId: ExperienceOverviewPageViewId.Overview,
			iconContext: {
				iconClass: 'fa-grip-horizontal',
				iconStyle: 'fa-solid',
				text: 'Overview',
				hideText: 'never',
			},
			customSort: '1-Overview-1'
		},

	];
	constructor() {
		super(ExperienceOverviewService._viewDroplistItems, ExperienceOverviewService.name, ExperienceOverviewPageTabId.Overview, ExperienceOverviewPageViewId.Overview);
	}

	public get viewId() {
		return ExperienceOverviewPageViewId;
	}

}